import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=c849131a&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c849131a",
  null
  
)

export default component.exports